<template>
  <div>
    <div v-if="load_show">
      <load></load>
    </div>
    <!-- header-->
    <headertop></headertop>

    <div class="main">
      <div class="title">
        <h1 class="left" @click="search_click()" style="cursor: pointer;"><i class="el-icon-notebook-2"></i> 列表</h1>
        <span class="right">
          <!-- <el-button round  type="primary" @click="AI_consult()">
            <span>
              <img  src="../../../../assets/consult_AI.png"style="height: 1.25rem;">
            </span>
            AI咨询</el-button> -->
            <el-button round  type="primary" @click="input_consult()">
              <span>
                <img  src="../../../../assets/consuit.png"style="height: 1.25rem;">
              </span>
              人工咨询</el-button>
        </span>
      </div>
      <!-- 搜索框 -->
      <el-row >
        <el-input placeholder="搜索提问内容" prefix-icon="el-icon-search" @keyup.enter.native="search_click()" v-model.trim="search" style="width: 90%;margin: 0 5%;"></el-input>
        <el-table
          :data="consult_list.data"
           style="width: 90%;margin: 0 5%;">
          <!-- <el-table-column prop="content" sortable label="主题">
          </el-table-column> -->
          <el-table-column prop="num" sortable label="编号" width="100" >
          </el-table-column>
          <el-table-column label="主题" prop="tagNumber" >
              <template slot-scope="scope">
                <el-row style="display: flex; align-items: center;">
                  <img v-if="scope.row.watch_status!=1" style="width: 10px; height: 10px; margin-right: 0.625rem;" src="../../../../assets/red.jpg"/>
                    <el-popover placement="top-start"
                                width="400"
                                trigger="hover"
                                :content="scope.row.content">
                        <div slot="reference" class="twoLineCls">{{scope.row.content}}</div>
                    </el-popover>
                </el-row>
              </template>
          </el-table-column>
          <el-table-column prop="time" sortable label="时间" width="100" >
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="100" >
            <template slot-scope="scope">
                <el-button type="text" size="small"  @click="see_info(scope.row.num)">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="block center">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="(consult_list.current_page*1)" :page-sizes="[10, 20, 30, 40]" :page-size="(consult_list.per_page*1)"
            layout="total, sizes, prev, pager, next, jumper" :total="consult_list.total">
          </el-pagination>
        </div>
      </el-row>

    </div>
    <footerbom></footerbom>
    <el-dialog title='咨询入口' :visible.sync="consult.show">
      <el-select v-model="consult.value" placeholder="请选择想要咨询的模块">
          <el-option
            v-for="item in consult.type_list"
            :key="item.num"
            :label="item.name"
            :value="item.num">
          </el-option>
        </el-select>
      <el-input  style="margin-top: 1.25rem;" type="textarea" autosize v-model="consult.input" placeholder="请输入您的问题"></el-input>
      <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="consultback(0)">确 定</el-button>
          <el-button @click="consult.show = false " >取 消</el-button>
        </div>
    </el-dialog>

    <el-dialog  :visible.sync="consult_info.show" width="70%" :before-close="handleClose">
      <!-- <h5>问题{{consult_info.list.title.content}}</h5> -->

      <div style="background-color:rgb(	97, 136, 202);padding: 1.25rem; color: white;" ref="con_h">
        <el-row>
          <el-row >
            <el-popover placement="top-start"
                        width="500"
                        trigger="hover"
                        :content="consult_info.list.title.content">
                <div slot="reference" class="twoLineCls">问题：{{consult_info.list.title.content}}</div>
            </el-popover>
          </el-row>
        </el-row>
        <el-row style="margin-top: 0.625rem; word-wrap:break-word;">
          顾问：{{consult_info.list.title.moderator}}
        </el-row>
        <el-row style="margin-top: 0.625rem; word-wrap:break-word;">
          时间：{{consult_info.list.title.time}}
        </el-row>
      </div>
      <div :style='{height:dialog_height}' class="over" ref="scrollContainer" >
        <el-row v-for="(item,index) in consult_info.list.list" :key="index">
          <!-- <el-row style="margin-top: 1.625rem;">
            <el-row v-if="item.from==0">
              <span style="float: right;">{{item.time}}</span>
               {{consult_info.list.title.moderator}}:
               <el-row style="background-color: #f6f8ff; border-radius: 4px;padding: 0.625rem; margin-top: 10px;">
                 {{item.content}}
               </el-row>
            </el-row>
            <el-row v-else>
              我：
              <span style="float: right;">{{item.time}}</span>
              <el-row style="border: 1px solid #EBEEF5; background-color: #f6f8ff;; border-radius: 4px;padding: 0.625rem; margin-top: 10px;">
                {{item.content}}
              </el-row>
            </el-row>
          </el-row> -->
          <el-row style="margin-top: 1.25rem;" >
            <el-row style="color: #999999;text-align: center; margin: 1.25rem 0; ">
              {{item.time}}
            </el-row>
           <el-row  v-if="item.from==0">
             <el-row style="display: flex;">
               <el-row style="margin-right: 0.625rem;">
                 <img src="../../../../assets/share_consult_info_t.png" style="width: 2vw;" alt="">
               </el-row>
               <el-row>
                 <div  class="content_img" style="background-color: #f6f8ff; border-radius: 4px;padding: 0.625rem; " v-html="item.content"></div>
               </el-row>
             </el-row>
           </el-row>
           <el-row  v-else>
             <el-row style="display: flex;float: right;">
               <div class="content_img" style="background-color: #f6f8ff; border-radius: 4px;padding: 0.625rem; " v-html="item.content"></div>
               <el-row style="margin-left: 0.625rem;">
                 <img src="../../../../assets/share_consult_info_s.png" style="width: 2vw;" alt="">
               </el-row>
             </el-row>
           </el-row>
          </el-row>
        </el-row>
        <el-row  v-if="consult_info.ai">
          <el-row style="text-align: center;margin-top: 0.625rem;color: #909399;">问题已收到，我们将尽快答复</el-row>
          <!-- <el-row style="display: flex;float: right;">
            <el-row style="background-color: #f6f8ff; border-radius: 4px;padding: 0.625rem; ">问题已收到，我们将尽快答复</el-row>
            <el-row style="margin-left: 0.625rem;">我</el-row>
          </el-row> -->
        </el-row>
      </div>
      <!-- <el-row style="display: flex; padding: 0 1.25rem ;">
        <el-input v-model="consult_info.input" type="textarea" placeholder="请输入您想问的问题,点击发送" style="width: 90%;margin-right: 0.625rem;"></el-input>
        <el-button type="primary"  @click="consultback(consult_info.list.title.num)">发 送</el-button>
      </el-row> -->
         <el-row style=" padding:  1.25rem ;">
           <el-col :span='20' >
             <quill-editor
                style="height:5rem"
                 v-model="consult_info.input"
                 ref="myQuillEditor"
                 :options="editorOption">
             </quill-editor>
           </el-col>
           <el-col :span='3' :offset='1'>
             <el-button  style="position: absolute;bottom: 0;" type="primary"  @click="consultback(consult_info.list.title.num)">发 送</el-button>
           </el-col>
         </el-row>
    </el-dialog>

    <el-dialog  :visible.sync="question.show" width="70%" :before-close="AI_handleClose">
      <H4 style="color: red;">提示</H4>
      <!-- <H4 style="color: red;">1.此功能正在测试中，如有问题敬请见谅</H4> -->
      <H4 style="color: red;">在此询问的内容，我们不做记录，回复仅供参考，请知悉</H4>
      <H4 style="text-align: center;" v-if="question.list.list.length==0">请说出您的问题</H4>
      <div :style='{height:dialog_height}' class="over" ref="scrollContainer_AI">
        <el-row v-for="(item,index) in question.list.list" :key="index">
          <el-row style="margin-top: 1.625rem;">
            <el-row v-if="item.from==0">
               AI:
               <el-row  v-html="`${item.content}`.replace(/\n/g,'<br/>')" style="background-color: #f6f8ff; border-radius: 4px;padding: 0.625rem; margin-top: 10px;">
               </el-row>
            </el-row>
            <el-row v-else>
              我：
              <el-row v-html="item.content" style="border: 1px solid #EBEEF5; background-color: #f6f8ff;; border-radius: 4px;padding: 0.625rem; margin-top: 10px;">
              </el-row>
            </el-row>
          </el-row>
        </el-row>
        <el-row v-if="question.deng_show" style="text-align: center;margin-top: 0.625rem;color: #909399;">正在组织语言请稍等......</el-row>
      </div>
      <el-row style="display: flex; padding: 0 1.25rem ;">
        <el-input v-model="question.input"  :disabled="question.input_show" type="textarea" placeholder="请输入您想问的问题,点击发送" style="width: 90%;margin-right: 0.625rem;"></el-input>
        <el-button type="primary"  v-if="question.input_show" disabled>发 送</el-button>
        <el-button type="primary"  @click="questionback()" v-else >发 送</el-button>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
  import Header from '../../../../components/index/public/NavHeader.vue';
  import Footer from '../../../../components/index/public/NavFooter.vue';
  import load from '../../../../components/load.vue';

  import { quillEditor } from 'vue-quill-editor'

  import 'quill/dist/quill.core.css'
  import 'quill/dist/quill.snow.css'
  import 'quill/dist/quill.bubble.css'
  export default {
    data() {
      return {
        editorOption: {
          modules: {
            toolbar: [
              ['image'] // 链接、图片、视频
            ]
          },
          placeholder: '请输入您的问题'
        },
        question:{
          list:{
          title:{},
          list:[]
          },
          show:false,
          title:'',
          input:'',
          type:'',//分类
          deng_show:false,
          input_show:false
        },
        load_show:false,
        dialog_height:'',
        consult:{
          show:false,
          input:'',
          value:'',
          type_list:[]
        },
        consult_list:{
          data:[],
          total: 0, // 总条数
          per_page:this.$route.query.per_page,
          current_page:this.$route.query.current_page, // 当前页码
        },
        search: '',
        consult_info:{
          ai:false,
          list:{
          title:{},
          list:[]
          },
          show:false,
          title:'',
          input:'',
          type:'',//分类
        },
      }
    },
    components: {
      headertop: Header,
      footerbom: Footer,
      load:load,
      quillEditor:quillEditor

    },
    mounted:function(){
      this.dialog_height=document.documentElement.clientHeight * 0.5+'px'
      this.get_type()
      this.get_consult_list()
    },
    methods: {
      AI_handleClose(done){
        this.question.list.list=[]
        done();
      },
      AI_consult(){
        let _this=this
        _this.question.show=true
      },
      questionback(){
        let _this=this
        let type={
          content:_this.question.input,
          from:1
        }
        _this.question.list.list.push(type)
        _this.question.deng_show=true
        _this.question.input_show=true
        _this.$nextTick(() => {
          const container = _this.$refs.scrollContainer_AI;
          container.scrollTop = container.scrollHeight;
        });
        _this.axios.post('/v2/user_chat/send', {
          data: _this.question.input //注意post请求发送参数的方式和get请求方式是有区别的
        }).then(function(res) {
          if(res.status=='200'){
              _this.question.deng_show=false
              _this.question.input_show=false
              _this.question.input=''
              let type={
                content:res.data.data,
                from:0
              }
              _this.question.list.list.push(type)
              _this.$nextTick(() => {
                const container = _this.$refs.scrollContainer_AI;
                container.scrollTop = container.scrollHeight;
              });

          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        })
      },
      handleClose(done) {
        let _this=this
        if(_this.consult_info.input!=''){
          _this.$confirm('您的消息还未发送，确认关闭？')
              .then(_ => {
                _this.load_show=true
                done();
                _this.consult_info.input=''
                  var t
                clearTimeout(t)
                t = setTimeout(function() {

                  _this.$router.go(0)
                }, 1000)
              })
              .catch(_ => {});
         }else{
           _this.load_show=true
           done();
           _this.consult_info.input=''
           var t
           clearTimeout(t)
           t = setTimeout(function() {

             _this.$router.go(0)
           }, 1000)

         }
      },
      see_info(num){
        let _this=this
        _this.axios.get('/v2/user/gxp_msg_info',{params:{num:num}}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.consult_info.list=res.data.data
              _this.consult_info.show=true
              _this.consult_info.title=res.data.data.title.name
              _this.consult_info.type=res.data.data.title.type
              let type={
                content:res.data.data.title.content,
                from:"1"
              }
              _this.consult_info.list.list.unshift(type)
              if(_this.consult_info.list.list.length==1 || _this.consult_info.list.list[_this.consult_info.list.list.length-1].from!='0'){
                _this.consult_info.ai=true
              }
              _this.$nextTick(() => {

                _this.load_show=true
                let timer = setTimeout(() => {
                  //需要定时执行的代码
                  const container = _this.$refs.scrollContainer;
                  container.scrollTop = container.scrollHeight;
                  clearTimeout(timer)
                  _this.load_show=false
                  }, 100)
              });
            }else{
              _this.$message.error(res.data.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },
      search_click(){
        let _this=this
        _this.$router.push({path:'/consult',query:{per_page:10,current_page:1}})
        _this.consult_list.per_page=10
        _this.consult_list.current_page=1
        _this.get_consult_list()
      },
      get_consult_list(){
        let _this=this
        _this.load_show=true
        _this.axios.get('/v2/user/gxp_msg',{params:{limit:_this.consult_list.per_page ,page :_this.consult_list.current_page,keyword:_this.search}}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.load_show=false
              _this.consult_list=res.data.data
            }else{
              _this.$message.error(res.data.msg)
              _this.load_show=false
            }
          }else{
            _this.$message.error('服务器内部错误')
            _this.load_show=false
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
          _this.load_show=false
        });
      },
      input_consult(){
        this.consult.show=true
      },
      consultback(fid){
        let _this=this
        let data={}
        if(fid==0){
           data={
           type:_this.consult.value,
           content:_this.consult.input,
           fid:fid
          }
        }else{
           data={
           type:_this.consult_info.type,
           content:_this.consult_info.input,
           fid:fid
          }
        }
        _this.axios.post('/v2/user/save_gxp_msg', {
          data: data //注意post请求发送参数的方式和get请求方式是有区别的
        }).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
               _this.$message.success(res.data.msg)
               if(fid==0){
                 _this.$router.go(0)
                 // _this.consult.input=''
                 // _this.consult.show=false
               }else{
                 _this.consult_info.input=''
                 _this.see_info(fid)
               }

            }else{
              _this.$message.error(res.data.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        })
      },
      get_type(){
        let _this=this
        _this.axios.get('/v2/user/feedback_type',
        {params:{type:'GXP'}}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.consult.type_list=res.data.data
            }else{
              _this.$message.error(res.data.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },
      handleSizeChange(val) {
        let _this=this
        // _this.consult_list.current_page = 1;
        // _this.consult_list.per_page = val;
        _this.$router.push({path:'/consult',query:{per_page:val,current_page:1}})
        _this.$router.go(0)
      },
      handleCurrentChange(val) {
        let _this=this
        // this.note.current_page = val;
        _this.$router.push({path:'/consult',query:{per_page:10,current_page:val}})
        _this.$router.go(0)
      },
    },
  }
</script>

<style scoped>
  .twoLineCls{
    cursor: pointer;
  	text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
       text-overflow: ellipsis;
       display: -webkit-box;
       -webkit-line-clamp: 2;
       line-clamp: 2;
       -webkit-box-orient: vertical;
  }

  .header_div {
    z-index: 9999;
  }

  .main {
    min-height: calc(100vh - 330px);
    width: 70%;
    padding: 20px;
    margin: 0 15%;
    z-index: 100;
    background-color: white;
  }

  .title {
    padding: 20px;
    overflow: hidden;

  }

  h1 {
    margin: 0;
  }

  /* 分页 */
  .block {
    margin: 30px 0;
  }
  .over{
    overflow: auto;
    padding: 0 1.25rem;
    margin-bottom: 0.625rem;
    margin-top: 0.625rem;
  }
  ::-webkit-scrollbar {
    width: 6px;
  }

  ::-webkit-scrollbar-track {
    background: transparent;
  }

  ::-webkit-scrollbar-thumb {
    background: rgb(154, 155, 158);
    border-radius: 10px;
  }
  .content_img >>> img {
  margin: 20px;
  width: 37vw;
  }
</style>



// WEBPACK FOOTER //
// src/view/index/Mine/consult/consult.vue